<template>
  <div class="cart-delivery" :class="{'is-loading': items === null}">
    <p class="cart-title">{{ Translator('front.cart.delivery.title') }}</p>
    <div class="cart-delivery-list" v-if="items">

      <div class="cart-radio" v-for="item in items" :key="item.id">
        <div class="cart-radio-wrapper" :class="{'is-checked': form.delivery === item['@id']}">
          <label class="cart-radio-container" :for="'delivery-item-' + item.id"
            v-on="{ touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } form.delivery = item['@id']; onChange(); onScroll = false; }}">
            <input type="radio" v-model="form.delivery" :value="item['@id']" @change="onChange" :id="'delivery-item-' + item.id">
            <div class="cart-radio-content">
              <p class="cart-radio-title">{{ item.name }}</p>
            </div>
            <div class="cart-radio-price">
              <p class="cart-radio-value" v-if="item.priceTtc === 0">{{ Translator('front.cart.delivery.free') }}</p>
              <div v-else>
                <p class="cart-radio-value" >
                  <template v-if="displayedHt">{{ (item.price /100) | toFixed(2) }} € <sup>{{ Translator('front.cart.price_ht') }}</sup></template>
                  <template v-else>{{ (item.priceTtc /100) | toFixed(2) }} €</template>
                </p>
              </div>
            </div>
          </label>
          <div class="cart-radio-more" v-if="form.delivery === item['@id']">
            <label class="cart-radio-container" v-if="item.isWithTransporter" :for="'delivery-item-' + item.id">
              <div class="cart-radio-content">
                <p class="cart-delivery-address">
                  <span v-if="cart.shippingAddress.company">{{ cart.shippingAddress.company }}<br></span>
                  {{ cart.shippingAddress.street }}<br>
                  <span v-if="cart.shippingAddress.complement">{{ cart.shippingAddress.complement }}<br></span>
                  {{ cart.shippingAddress.postcode }} {{ cart.shippingAddress.city }}, {{ cart.shippingAddress.countryCode }}
                </p>
              </div>
            </label>
            <div class="cart-radio-container cart-delivery-insurance" v-if="item.isWithTransporter">
              <div class="cart-radio-content">
                <div class="form-group checkbox">
                  <label :for="'delivery-insurance-' + item.id">
                    <input type="checkbox" v-model="cart.deliveryInsurance" @change="onChangeInsurance($event)" :id="'delivery-insurance-' + item.id">
                    <strong>{{ Translator('front.cart.delivery.insurance') }}</strong><br>
                    {{ Translator('front.cart.delivery.insurance_details') }}
                  </label>
                </div>
              </div>
              <div class="cart-radio-price">
                <p class="cart-radio-value" >
                  <template v-if="displayedHt">{{ (item.insurancePrice /100) | toFixed(2) }} € <sup>{{ Translator('front.cart.price_ht') }}</sup></template>
                  <template v-else>{{ (item.insurancePriceTtc /100) | toFixed(2) }} €</template>
                </p>
              </div>
            </div>
            <div class="cart-bloc-info" v-if="item.description">
              <div class="cart-bloc-info-wrapper">
                <div class="cart-bloc-info-content">
                  <i class="ico ico-info"></i>
                  <p class="cart-bloc-info-txt" v-html="item.description"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .cart-delivery {
    position: relative;
    min-height: rem(300);
    &.is-loading {
      @include loader;
    }
  }
  .cart-delivery-list {
    @include desktop {
      width: 80%;
    }
  }
  .cart-radio {
    .cart-radio-wrapper {
      padding: 0 !important;
      display: block !important;
      &::before {
        top: rem(32) !important;
      }
    }
    .cart-radio-container {
      display: flex;
      padding: rem(20) rem(30);
      padding-left: rem(40);
    }
    .cart-radio-content {
      width: 100%;
    }
    .cart-radio-value {
      white-space: nowrap;
    }
    .cart-delivery-address {
      position: relative;
      padding-bottom: rem(20);
      line-height: 1.5;
      color: $black;
      padding-left: rem(60);
      white-space: break-spaces;
      &::after {
        content: '';
        width: rem(4);
        height: rem(4);
        border-radius: 100%;
        display: block;
        position: absolute;
        left: rem(39);
        top: 0;
        background-color: $color-second;
      }
      &::before {
        content: '';
        position: absolute;
        display: block;
        top: 0;
        left: rem(40);
        bottom: rem(22);
        width: rem(1);
        background-color: $grey-light;
      }
    }
    .cart-radio-more {
      .cart-radio-container {
        padding: 0;
      }
    }
    .cart-delivery-insurance {
      border-top: rem(1) solid $grey-light;
      padding: rem(20) rem(30) !important;
      strong {
        color: $blue-udark;
      }
      .checkbox {
        padding-left: rem(30);
        position: relative;
      }
      [type=checkbox] {
        position: absolute;
        left: 0;
        width: rem(18);
        height: rem(18);
        margin-top: rem(3);
        &::before {
          width: rem(10);
          height: rem(10);
          left: rem(3);
          top: rem(3);
          border-radius: rem(2);
        }
      }
    }
  }
  .cart-bloc-info {
    margin-top: rem(20);
    position: relative;
    background-color: rgba($blue, 0.1);
    color: $black;
    border-radius: rem(9);
  }
  .cart-bloc-info-wrapper {
    padding: rem(15) rem(25);
  }
  .cart-bloc-info-content{
    margin-bottom: rem(10);
    display: flex;
    gap: rem(10);
    .ico-info{
      height: rem(30);
      width: rem(30);
      font-size: rem(30);
      color: $blue-mdark;
      margin-top: rem(-5);
    }
  }
  .cart-bloc-info-title{
    color: $blue-mdark;
  }
</style>
<script>
import OrdersService from '@/services/Orders';
import UsersService from '@/services/Users';

export default {
  name: 'cart-delivery',
  data () {
    return {
      onScroll: null,
      items: null,
      user: UsersService.datas,
      cart: this._parseCart(OrdersService.cart),
      form: {
        delivery: null,
      }
    }
  },
  created() { },
  beforeDestroy() {
    OrdersService.off('updated', this._onUpdateCart);
  },
  mounted() {
    this._onUpdateCart = this._onUpdateCart.bind(this);
    if(OrdersService.cart.shippingMethod) this.form.delivery = OrdersService.cart.shippingMethod['@id'];
    OrdersService.getShippings().then( res => {
      this.items = res.data['hydra:member'];
    });

    OrdersService.on('updated', this._onUpdateCart);
    this.cart = this._parseCart(OrdersService.cart);
  },

  computed: {
    displayedHt: function() {
      return this.cart?.displayedHt;
    }
  },

  methods: {
    onChange() {
      this.cart.deliveryInsurance = false;
      OrdersService.update({
        shippingMethod: this.form.delivery
      });
    },

    onChangeInsurance(pEvt) {
      pEvt.preventDefault();
      pEvt.stopImmediatePropagation();
      OrdersService.update({
        deliveryInsurance: this.cart.deliveryInsurance
      });
    },

    _onUpdateCart(res) {
      this.cart = this._parseCart(res);
    },

    _parseCart(datas) {
      return datas;
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
}
</script>
